<div class="dialog-wrapper">
  <!-- Header -->
  <h1 mat-dialog-title class="header">
    {{ title }} Preview
  </h1>

  <!-- Body -->
  <mat-dialog-content class="mx-1">
    <div class="flex-layout fx-layout-row fx-align-start">
      <div class="preview" [innerHTML]="sanitizer.bypassSecurityTrustHtml(contentText)">
      </div>
    </div>
  </mat-dialog-content>

  <!-- Footer -->
  <mat-card-actions align="end" class="fx-layout-row fx-layout-xs-column mx-1 my-2">
    <button mat-raised-button mat-dialog-close color="primary">Close</button>
  </mat-card-actions>
</div>
